
// EditarFornecedor.js

import React, { useState, useEffect } from 'react';
import NameField from './NameField';
import CodigoField from './CodigoField';
import DatepickerField from './DatepickerField';
import EmailField from './EmailField';
import PhoneField from './PhoneField';
import CnpjField from './CnpjField';
import CpfField from './CpfField';
import InscEstField from './InscEstField';
import InscMunField from './InscMunField';
import CepField from './CepField';
import NumeroField from './NumeroField';
import ComplementoField from './ComplementoField';
import CurrencyField from './CurrencyField';
import FormaPagamentoSelect from './FormaPagamentoSelect';
import CondPagamentoSelect from './CondPagamentoSelect';
import Box from '@mui/material/Box';
//import Axios from 'axios';
import api from '../config/axiosConfig';

function EditarFornecedor({ fornecedor, handleFornecedorEditado, handleCancelaEdit, isEditing }) {
  const [formData, setFormData] = useState(fornecedor);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setFormData(fornecedor);
  }, [fornecedor]);


  const paymentMethods = ['Em Espécie', 'PIX', 'Cartão', 'Boleto', 'Depósito', 'Transferência'];
  const conditionMethods = ['À Vista', '15 dias', '30 dias', '60 dias', '30-60 dias', '30-60-90 dias'];

  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleAddressChange = (address) => {
    setFormData((prevData) => ({
      ...prevData,
      logradouro: address.logradouro,
      bairro: address.bairro,
      cidade: address.cidade,
      uf: address.uf,
    }));
  };


  // Função para obter a data atual no formato yyyy-mm-dd
  const getDataAtualISO = () => {
    const data = new Date();
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
    const ano = data.getFullYear();
    return `${ano}-${mes}-${dia}`;
  };


  const handleSaveClick = async () => {
    if (isSaving) {
      return;
    }

    const mandatoryFields = ['nomefor', 'codfor', 'fone', 'email','cnpjfor'];
  //  const hasErrors = mandatoryFields.some(field => formData[field]?.trim() === '');

  // Verificações específicas para cada campo obrigatório
  const hasErrors = mandatoryFields.some(field => {
    if (field === 'codfor') {
      return !formData[field] || typeof formData[field] !== 'number';
    } else {
      return !formData[field] || typeof formData[field] !== 'string' || formData[field].trim() === '';
    }
  });
  if (hasErrors) {
    alert('Os Campos: Nome, Código, Email, Fone e CNPJ são obrigatórios.');
    return;
  }

    
    // Se a data de cadastro estiver vazia, define a data atual
    if (!formData.dtcadastro.trim()) {
      formData.dtcadastro = getDataAtualISO();
    }


    setIsSaving(true);

    try {
      console.log('Enviando dados do fornecedor:', formData);
      const response = await api.put(`/alterarfornecedor/${fornecedor.id}`, formData, {
        headers: { 'Content-Type': 'application/json' },
      });
      console.log('Fornecedor editado com sucesso:', response.data);
      handleFornecedorEditado(response.data); // Atualiza a lista de fornecedors e redireciona
    } catch (error) {
      if (error.response) {
        console.log('Erro ao editar fornecedor:', error.response.data);
      } else {
        console.log('Erro ao editar fornecedor:', error.message);
      }
    } finally {
      setIsSaving(false);
    }
  };


  return (

    <div
      style={{
        minHeight: 'calc(100vh - 20px)',
        maxWidth: '900px',
        paddingTop: '10px',
        marginLeft: '0px',
        margin: '0 auto', // Centralizando o container
        textAlign: 'center', // Alinhamento central
      }}
    >

        <div style={{ marginBottom: '10px', marginTop: '10px' }}>
          <h3>Edição do Fornecedor</h3>
        </div>

        <div style={{ textAlign: 'left', marginLeft: '20px' }}>

          <div style={{ display: 'flex', marginBottom: '25px' }}>

            <div style={{ marginRight: '20px', width: '520px', height: '30px' }}>
              <label style={{ display: 'block', width: '520px' }}>Nome:</label>
              <NameField value={formData.nomefor} onChange={value => handleChange('nomefor', value)} />
            </div>
          
            <div style={{ width: '100px', marginRight: '20px', height: '30px' }}>
              <label style={{ display: 'block', width: '100px' }}>Código:</label>
              <CodigoField value={formData.codfor} readOnly />
            </div>
          
            <div style={{ width: '120px', height: '28px' }}>
              <label style={{ display: 'block', width: '150px',  marginBottom: '0px' }}>Data de Cadastro:</label>
              <DatepickerField  style={{ width: '120px', height: '28px' }} value={formData.dtcadastro} onChange={value => handleChange('dtcadastro', value)} />
            </div>
          </div>

          <div style={{ display: 'flex', marginBottom: '25px' }}>
            <div style={{ width: '420px', height: '30px', marginRight: '20px' }}>
              <label style={{ display: 'block', width: '410px' }}>E-mail:</label>
              <EmailField value={formData.email} onChange={value => handleChange('email', value)} />
            </div>
            <div style={{ width: '200px', height: '30px', marginRight: '20px' }}>
              <label style={{ display: 'block', width: '200px', marginBottom: '0px' }}>Telefone:</label>
              <PhoneField value={formData.fone} onChange={value => handleChange('fone', value)} />
            </div>
            <div style={{ width: '200px', height: '30px' }}>
              <label style={{ display: 'block', width: '200px', marginBottom: '0px' }}>Celular:</label>
              <PhoneField value={formData.celular} onChange={value => handleChange('celular', value)} />
            </div>
          </div>

          <div style={{ display: 'flex', marginBottom: '25px' }}>
            <div style={{ width: '200px', marginRight: '20px', height: '30px' }}>
              <label style={{ display: 'block', width: '200px' }}>CNPJ:</label>
              <CnpjField value={formData.cnpjfor} onChange={value => handleChange('cnpjfor', value)} />
            </div>
            <div style={{ width: '200px', marginRight: '20px', height: '30px' }}>
              <label style={{ display: 'block', width: '200px', marginRight: '20px' }}>CPF:</label>
              <CpfField value={formData.cpfcli} onChange={value => handleChange('cpfcli', value)} />
            </div>
            <div style={{ width: '200px', marginRight: '20px', height: '30px' }}>
              <label style={{ display: 'block', width: '200px', marginBottom: '0px', marginRight: '20px' }}>Inscrição Estadual:</label>
              <InscEstField value={formData.inscricaoest} onChange={value => handleChange('inscricaoest', value)} />
            </div>
            <div style={{ width: '200px', height: '30px' }}>
              <label style={{ display: 'block', width: '200px', marginBottom: '0px' }}>Inscrição Municipal:</label>
              <InscMunField value={formData.inscricaomun} onChange={value => handleChange('inscricaomun', value)} />
            </div>
          </div>

        <div style={{ display: 'flex', marginBottom: '0px', marginTop: '0px' }}>
          <div style={{ width: '120px', marginRight: '20px', marginBottom: '0px',marginTop: '0px' }}>
            <CepField 
            value={formData.cep} 
            onChange={value => handleChange('cep', value)} 
            onAddressChange={handleAddressChange}/>
          </div>

          <div style={{ width: '100px', marginRight: '20px', marginLeft: '440px' }}>
            <label style={{ display: 'block', width: '100px', marginRight: '20px' }}>Número:</label>
            <NumeroField value={formData.numero} onChange={value => handleChange('numero', value)} />
          </div>

          <div style={{ width: '160px' }}>
              <label style={{ display: 'block', width: '160px' }}>Complemento:</label>
              <ComplementoField value={formData.complemento} onChange={value => handleChange('complemento', value)} />
          </div>
        </div>

         
      <div style={{ display: 'flex', marginBottom: '25px' }}>
        <div style={{ width: '120px', marginRight: '0px', marginBottom: '0px' }}>
          <label style={{ display: 'block', width: '120px', marginBottom: '0px' }}>Crédito:</label>
          <CurrencyField value={formData.credito} onChange={value => handleChange('credito', value)} />
        </div>
                    
        <div style={{ width: '200px', marginLeft: '0px', marginBottom: '0px' }}>
         <FormaPagamentoSelect 
          paymentMethods={paymentMethods} 
          selectedMethod={formData.formapag} 
          onChange={(value) => handleChange('formapag', value)} 
        />
        </div>

        <div style={{ width: '230px', marginLeft: '20px', marginBottom: '0px' }}>
         <CondPagamentoSelect 
          conditionMethods={conditionMethods} 
          selectedMethod={formData.condpag} 
          onChange={(value) => handleChange('condpag', value)} 
        />
        </div>

        </div>

          <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0px' }}>
            <button  type="button" className='btn-menu' onClick={handleSaveClick} style={{ width: '100px', height: '30px', padding: '3px 5px', marginRight: '50px', color: 'inherit' }}>
              {isSaving ? 'Salvando...' : 'Salvar'}
            </button>
            <button  type="button" className='btn-menu' onClick={handleCancelaEdit} style={{ width: '100px', height: '30px', padding: '3px 5px', color: 'inherit' }}>
              Cancelar
            </button>
            </div>
          </Box>

          
        </div>

    </div>
  );
};

export default EditarFornecedor;
